import { render, staticRenderFns } from "./DetailHas.vue?vue&type=template&id=1ab2cd87&scoped=true"
import script from "./DetailHas.vue?vue&type=script&lang=js"
export * from "./DetailHas.vue?vue&type=script&lang=js"
import style0 from "./DetailHas.vue?vue&type=style&index=0&id=1ab2cd87&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab2cd87",
  null
  
)

export default component.exports